import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Header } from "../../components/Header";
import { admin } from "../../lib/api";

export default function AdminLogin() {
  const [token, setToken] = useState("");
  const [error, setError] = useState(null);
  const nav = useNavigate();

  React.useEffect(() => {
    document.body.classList.add("light-admin");
    return () => document.body.classList.remove("light-admin");
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      const res = await admin.login(token);
      if (res.ok) {
        localStorage.setItem("cw_admin_token", res.token);
        nav("/admin/deal-board");
      }
    } catch {
      setError("Invalid admin token.");
    }
  };

  return (
    <div className="cw-admin-shell" data-testid="admin-login-page">
      <Header variant="light" />
      <div style={{ maxWidth: 480, margin: "80px auto", padding: 32 }}>
        <div className="cw-eyebrow">Crowther Internal</div>
        <h1 className="cw-display-l" style={{ marginTop: 12 }}>Admin sign-in.</h1>
        <p className="cw-body" style={{ marginTop: 16, color: "rgba(22,30,27,0.72)" }}>
          Enter the internal admin token to access the Deal Board and content administration.
        </p>
        <form onSubmit={submit} style={{ marginTop: 32 }}>
          <input
            className="cw-input"
            type="password"
            placeholder="Admin token"
            value={token}
            onChange={(e) => setToken(e.target.value)}
            data-testid="admin-token-input"
          />
          {error && (
            <div className="cw-small" style={{ color: "var(--cw-error)", marginTop: 12 }} data-testid="admin-login-error">
              {error}
            </div>
          )}
          <button
            type="submit"
            className="cw-btn light-primary"
            style={{ marginTop: 24, width: "100%" }}
            data-testid="admin-login-btn"
          >
            Sign in
          </button>
        </form>
      </div>
    </div>
  );
}
